function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

//redirect for QC location
$(function() {
  $(document.body).on('click','a.check--location',function(e){

    e.preventDefault();
    const $currentTarget = $(e.currentTarget);
    const location = Alpine.store('location').city;
    const type= $currentTarget.attr('redirect-type');
    const address= $currentTarget.attr('h-href');

    // alert(`your current location is set as ${location}. Are you sure you want to redirect?`)

    if(location === 'Quebec'){
      window.location.href=window.Shopify.routes.root+'collections/qc-products'+'?view=qc-'+type;
    }else{
      window.location.href=address;
    }

  })
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');
  document.querySelector('body')?.classList.remove('drawer--visible');
  document.querySelector('html')?.classList.remove('scroll-locked');
  document.querySelector('body')?.classList.remove('scroll-locked');
  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    let body = document.querySelector('body');
    if (body?.classList.contains('drawer--visible')) {
      body?.classList.remove('drawer--visible');
      document.querySelector('html')?.classList.remove('scroll-locked');
		  body?.classList.remove('scroll-locked');
    } else if (summary.getAttribute('aria-controls') === 'menu-drawer') {
      body?.classList.add('drawer--visible');
      document.querySelector('html')?.classList.add('scroll-locked');
		  body?.classList.add('scroll-locked');
	}
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

   if (elementToFocus) elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', 'false');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
    //init event change for live counter
    if (!this.parentElement.classList.contains('product-form__input')) return;
    this.initliveCounter();

    this.input.addEventListener('change', this.initliveCounter.bind(this));
    document.addEventListener('variant:livedataloaded', this.initliveCounter.bind(this));
    document.addEventListener('cart:updated', this.initliveCounter.bind(this));
    document.addEventListener('cart:addedpdp', this.initliveCounter.bind(this));

  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  //live counter for quantity fields
  initliveCounter() {
    const varDataHolder = document.querySelector('div#variantUnique');
    const variantId = varDataHolder.getAttribute('variant'),
      availableQuantity = varDataHolder.getAttribute('quantity');

    this.setAttribute('disabled', '');
    fetch('/cart.js')
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);
          return;
        }
        let foundVar = response.items.find(item => item.variant_id == variantId);
        let cartQuantity = foundVar ? foundVar.quantity : 0;
        let quantityCanbeAdded = availableQuantity - cartQuantity;
        //console.log(response.items);
        console.log('In Cart', cartQuantity);
        console.log('Available=>', availableQuantity);
        let price = $('fieldset #product-form.selected .price-item').text().replace(/\s+/g, "");;
        document.querySelector('button[name="add"]').setAttribute('data-analytics-property-product_price', price);
        let tempQuantity = quantityCanbeAdded ? quantityCanbeAdded : 1;
        this.input.value > quantityCanbeAdded ? this.input.value = tempQuantity : {};
        this.input.value >= quantityCanbeAdded ? this.input.nextElementSibling.setAttribute('disabled', '') :
          this.input.nextElementSibling.removeAttribute('disabled');
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        console.log(varDataHolder.getAttribute('variant'));
        this.removeAttribute('disabled');
      });

  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    this.html = document.querySelector('html');
    this.body = document.querySelector('body');
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => {
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    });
    this.querySelectorAll('button:not(button.collapsible)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.querySelectorAll('accordion-item a').forEach(a => a.addEventListener('click', this.onOverlayClick.bind(this)));
    document.querySelector('.drawer__underlay')?.addEventListener('click', this.onOverlayClick.bind(this));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    this.summaryElement = event.currentTarget;
    // console.log(summaryElement);
    const detailsElement = this.summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    const headerHeading = document.querySelector('.header__heading');
    const headerGetStartedButton = document.querySelector('.header__get-started-btn')
    const livechat = document.querySelectorAll('.zsiq_floatmain');

    if (!isOpen) {
      $zoho.salesiq.floatbutton.visible("hide");
    } else {
      $zoho.salesiq.floatbutton.visible("show");
    }

    function addTrapFocus() {
      trapFocus(this.summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      this.summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      if (isOpen) {
        //headerHeading
        //  headerHeading.style.visibility = 'visible';
        //  headerGetStartedButton.style.visibility = 'visible';
      }
      isOpen ? this.closeMenuDrawer(event, this.summaryElement) : this.openMenuDrawer(event, this.summaryElement);
    } else {
      setTimeout(() => {
        //headerHeading
        // headerHeading.style.visibility = 'hidden';
        // headerGetStartedButton.style.visibility = 'hidden';

        detailsElement.classList.add('menu-opening');
        detailsElement.setAttribute('open', 'true');
        this.summaryElement.setAttribute('aria-expanded', 'true');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : this.summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  onLinkClick() {
    this.onOverlayClick();
  }

  openMenuDrawer(event, summaryElement) {
    event.preventDefault();
    setTimeout(() => {
      this.mainDetailsToggle?.classList.add('menu-opening');
    });
    console.log(this.parentElement);
    this.mainDetailsToggle?.setAttribute('open', 'true');
    summaryElement.setAttribute('aria-expanded', 'true');
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  
  closeMenuDrawer(event, elementToFocus = false) {
    this.body?.classList.remove('drawer--visible');
    this.html?.classList.remove('scroll-locked');
	  this.body?.classList.remove('scroll-locked');

    console.log('closing menu drawer');
    if (event !== undefined) {
      
      // scrolling window to previous position
      const offsetY = Math.abs(parseInt(this.body?.style.top || 0, 10));
	    document.documentElement.style.removeProperty('overflow')
      this.body?.style.removeProperty('top');
      window.scrollTo(0, offsetY || 0);
      
      this.mainDetailsToggle?.classList.remove('menu-opening');
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onOverlayClick() {
			document.querySelectorAll('[id^="Details-"]').forEach((details) => {
				details.classList.remove('menu-opening');
				details.removeAttribute('open');
				details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
        document.querySelector('body')?.classList.remove('drawer--visible');
        document.querySelector('html')?.classList.remove('scroll-locked');
		    document.querySelector('body')?.classList.remove('scroll-locked');
      });
    document.documentElement.style.removeProperty('overflow');
    this.body?.style.removeProperty('top');
    const offsetY = Math.abs(parseInt(this.body?.style.top || 0, 10));
    window.scrollTo(0, offsetY || 0);
    this.mainDetailsToggle?.classList.remove('menu-opening');
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    // setTimeout(() => {
    //   if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    // });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', 'false');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.html = document.querySelector('html');
	  this.body = document.querySelector('body');
  }
  
  openMenuDrawer(summaryElement) {
    this.header = this.body?.querySelector('header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper')?.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    let headerOffsetHeight = (this.header?.getBoundingClientRect().bottom - this.borderOffset);
    document.documentElement.style.setProperty('--header-bottom-position', `${headerOffsetHeight}px`);
    const offsetY = window.pageYOffset;
    this.body.style.top = `${-offsetY}px`;
    this.html?.classList.add('scroll-locked');
	  this.body?.classList.add('scroll-locked'); 
    
    //     bodyInfo.addEventListener('touchmove', function(e) {
    //       e.preventDefault();
    //       console.log('touching 1');
    //     }, { passive: false });
    setTimeout(() => {
      this.mainDetailsToggle?.classList.add('menu-opening');
    });
    if (summaryElement) summaryElement?.setAttribute('aria-expanded', 'true');
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]')?.addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    console.log('openner ');
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal_dialog = document.querySelector(this.getAttribute('data-modal'));
      if (modal_dialog) modal_dialog.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {

let dtset = this.dataset.section;
    const inputs = this.querySelectorAll('input[type=radio]');
    inputs.forEach(function (el) {
      if (el.checked && !el.hasAttribute('disabled_cust')) {
        el.parentElement.classList.add('selected');
		
	    const productForm = document.getElementById(`product-form-${dtset}`);
	           if (!productForm) return;
	           const addButton = productForm.querySelector('[name="add"]');
	           const addButtonText = productForm.querySelector('[name="add"] > span');
	           // if (!addButton) return;
	           if (el.getAttribute('quantity') == 0) {
	             $('#qty').attr('attr', 'for_disable')
	             addButton.setAttribute('disabled', 'disabled');
	             addButtonText.textContent = 'Out of stock';
	             console.log('yes');
	           } else {
	             $('#qty').removeAttr('attr')
	             addButton.removeAttribute('disabled');
	             addButtonText.textContent = window.variantStrings.addToCart;
	             console.log('no');
	           }
		
		
		
      } else {
        el.parentElement.classList.remove('selected');
      }
    });
    //console.log(inputs.length);

    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.liveCounterHelper();
      this.updateSegmentData();

    }
  }
  
  updateSegmentData() {
  	const segmentElement = document.querySelector('button[data-analytics="select_add_to_cart"]');
    segmentElement.setAttribute('data-analytics-property-product_price', `${(this.currentVariant.price / 100).toFixed(2)}`);
  }

  liveCounterHelper() {
    const varDataHolder = document.querySelector('div#variantUnique');
    varDataHolder.setAttribute('variant', this.currentVariant.id);
    varDataHolder.setAttribute('quantity', this.querySelector('div#product-form.selected input').getAttribute('quantity'));
    document.dispatchEvent(new CustomEvent('variant:livedataloaded'));
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    //const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    //const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;

    if (parent.firstChild == newMedia) return;

    // modalContent.prepend(newMediaModal);
    // parent.prepend(newMedia);

    /*swapping */
    // swap(newMediaModal.parentNode.firstChild,newMediaModal);
    // swap(newMedia.parentNode.firstChild,newMedia);

    /* moved to main-product snippet*/
    /*swapping */
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if (this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    // window.setTimeout(() => {
    //   parent.scrollLeft = 0;
    //   parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    // });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
   
    // if(text=='Sold out'){
    //   text = 'Unavailable';
    // }

   
    // const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    // if (!productForm) return;
    // const addButton = productForm.querySelector('[name="add"]');
    // const addButtonText = productForm.querySelector('[name="add"] > span');
    //
    // if (!addButton) return;
    //
    // if (disable) {
    //   addButton.setAttribute('disabled', 'disabled');
    //   if (text) addButtonText.textContent = text;
    // } else {
    //   addButton.removeAttribute('disabled');
    //   addButtonText.textContent = window.variantStrings.addToCart;
    // }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class QuickAdd extends VariantSelects {
  constructor() {
    super();
    this.isDexcom = !!this.dataset.dexcom;
    this.btn = this.querySelector('button');
    this.variant = this.dataset.variantId;
    this.cartNotification = document.querySelector('cart-notification');

    this.btn.addEventListener('click', this.renderCart.bind(this));
  }

  async renderCart() {
    this.btn.classList.add('loader');

    console.log(this.dataset);
    // checking available item in current location
    let totalUsed = 0;
    const variantId = parseInt(this.variant);

    const quantityToAdd = 1;
    // const location = window.localStorage.getItem('__mednow_user_city') || 'Ontario';
    const location = Alpine.store('location').city;
    if(this.btn.classList.contains('annexe_2') && location==='Quebec'){
      const pr_link=this.closest('.grid__item').querySelector('a.card-information__text')
      console.log("annexe_2 redirect",pr_link.href);
      this.btn.classList.remove('loader');
      window.location.href=pr_link.href
      return;
    }
    const cartData = await fetch('/cart.js').then(data => data.json());
    const variantInCart = cartData.items.find(item => item.id === variantId);
    const locale = document.body.dataset.locale;
    console.log(locale)
    if (variantInCart) {
      totalUsed += variantInCart.quantity
    }

    // Per order limit
    const getOrderLimitBool = this.dataset.orderlimit;
    const getLimitPerOrder = this.dataset.limitperorder;

    
    const orderLimit = (typeof getOrderLimitBool !== "undefined" && getOrderLimitBool != "") ? getOrderLimitBool : false;
    const limitPerOrder = (typeof getLimitPerOrder !== "undefined" && getLimitPerOrder != "") ? getLimitPerOrder : 2;

    // console.log(limitPerOrder);

    // limit order quantity for a specific product
    if(orderLimit && (quantityToAdd + totalUsed) > limitPerOrder) {
      const errorWrapper = document.querySelector('.product-card-error-' + variantId);
      errorWrapper.removeAttribute('hidden');
      const enErrString = `The limit for this product is ${limitPerOrder} units per order.`;
      const frErrString = `La limite pour ce produit est de ${limitPerOrder} unités par commande.`;
      errorWrapper.querySelector('span').innerHTML = locale === 'en' ? enErrString : frErrString;
      this.btn.classList.remove('loader');
      return;
    }


    let availableQty = $(this).data('available');

    if (availableQty === undefined) {
      try {
        const availableInLocation = await fetch(`https://mednow-inventory.herokuapp.com/?variant=${variantId}&location=${location}`).then(res => res.json());
        availableQty = availableInLocation.node.available;
      } catch (e) {
        this.btn.classList.remove('loader');
        const errorWrapper = document.querySelector('.product-card-error-' + variantId);
        errorWrapper.removeAttribute('hidden');

        const enErrString = `Something went wrong. Please try again later.`;
        const frErrString = `Quelque chose s'est mal passé. Veuillez réessayer plus tard.`;
        errorWrapper.querySelector('span').innerHTML = locale === 'en' ? enErrString : frErrString;
      }
    }


    if (quantityToAdd > (availableQty - totalUsed)) {
      this.btn.classList.remove('loader');
      const errorWrapper = document.querySelector('.product-card-error-' + variantId);
      errorWrapper.removeAttribute('hidden');
      
      if (availableQty > 0) {
        const enErrString = `Only ${availableQty ? availableQty : 0} ${availableQty > 1 ? 'items are' : 'item is'} available at your location.`;
        const frErrString = `Seuls ${availableQty ? availableQty : 0} ${availableQty > 1 ? 'articles' : 'article'} sont disponibles chez vous.`;
        errorWrapper.querySelector('span').innerHTML = locale === 'en' ? enErrString : frErrString;
      } else {
        const enErrString = `No items available at your location.`;
        const frErrString = `Aucun article disponible à votre emplacement.`;
        errorWrapper.querySelector('span').innerHTML = locale === 'en' ? enErrString : frErrString;
      }

      if (totalUsed > 0) {
        const enErrString = `Only ${availableQty} ${availableQty > 1 ? 'items are' : 'item is'} available at your location and ${totalUsed} ${totalUsed > 1 ? 'items are' : 'item is'} already in your cart!`;
        const frErrString = `Seulement ${availableQty} ${availableQty > 1 ? 'articles' : 'article'} sont disponibles chez vous et ${totalUsed} ${totalUsed > 1 ? 'articles' : 'article'} sont déjà dans votre panier !`;
        errorWrapper.querySelector('span').innerHTML = locale === 'en' ? enErrString : frErrString;
      }

      return;
    }


    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    const itemData = {
      quantity: 1,
      id: this.variant
    };
    for (var key in itemData) {
      formData.append(key, itemData[key]);
    }
    if(!this.classList.contains('onboardingQuickAdd')){
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
    }
    formData.append('sections_url', window.location.pathname);
    config.body = formData;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        //descom logic
        if (this.isDexcom) window.location.href = "/cart"
        if (response.status) {
          // console.log(response.description);
          // this.handleErrorMessage(response.description);
          return;
        }

        this.btn.classList.add('added')
        this.setAttribute('added', true);
        if(!this.classList.contains('onboardingQuickAdd')){
          document.querySelector('#cart-icon-bubble').dispatchEvent(new Event('click'))
        }
		
      if(!this.classList.contains('onboardingQuickAdd')){
        this.cartNotification.renderContents(response);
      }

    
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        // this.cartNotification.open();
        this.btn.classList.remove('loader');
        // submitButton.classList.remove('loading');
        // submitButton.removeAttribute('aria-disabled');
        // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      });
    // this.btn.classList.remove('loader');
  }
}

customElements.define('quick-add', QuickAdd);

class facetsOptionSearch extends HTMLElement {
  constructor() {
    super();

    this.options = this.nextElementSibling.querySelectorAll('li');
    this.inputField = this.querySelector('.facets__search-input');

    this.bindSearch = (e) => {
      e.preventDefault();
      let timedCallback;
      clearTimeout(timedCallback)
      timedCallback = setTimeout(function () {
        this.search(e)
      }.bind(this), 500);
    }

    this.search = (e) => {
      const searchTerm = e.target.value;
      this.options.forEach(option => {
        const text = option.querySelector('.facets__option-text').innerText;

        if (text.trim().toLowerCase().includes(searchTerm.trim().toLowerCase())) {
          option.style.display = 'flex';
        } else {
          option.style.display = 'none';
        }
      })
    }

    this.inputField.addEventListener('keyup', this.bindSearch.bind(this))
  }
}

customElements.define('facets-option-search', facetsOptionSearch);

class Accordion extends HTMLElement {
	connectedCallback() {
		this.button = this.querySelector('button.collapsible');
		this.content = this.querySelector('.content');

		this.handleToggle = this.handleToggle.bind(this);
		this.button?.addEventListener('click', this.handleToggle);
	}

	handleToggle = (e) => {
		e.preventDefault();
		let accordion_items = document.querySelectorAll('accordion-item');
		if (this.classList.contains('active')) {
			this.classList.remove('active');
			this.content.style.maxHeight = null;
		} else if (
			this.parentElement?.parentElement?.classList.contains('active')
		) {
			this.classList.add('active');
			this.content.style.maxHeight = this.content.scrollHeight + 'px';
		} else {
			for (let i = 0; i < accordion_items.length; i++) {
				accordion_items[i].classList.remove('active');
			}
			this.classList.add('active');
			this.content.style.maxHeight = this.content.scrollHeight + 'px';
		}
		var x = this.button?.querySelector('.plus-icon');
		if (x) {
			if (x.style.display === 'none') {
				x.style.display = 'block';
			} else {
				x.style.display = 'none';
			}
		}
	};
}

customElements.define('accordion-item', Accordion);


// Med Review Page CTA
function openChat(e) {
  document.querySelector('.zsiq_floatmain.zsiq_theme1.siq_bR').click();
}
/*----------------------------
**** Recent Search System ****
----------------------------*/
// declaring variables and functions
let recentSearches = [];
let navForm = document.querySelector('form.search-modal__form');
let searchPageForm = document.querySelector('.template-search__search form');
let navSearchBar = document.querySelector('.search__input');
let searchPageInput = document.querySelector('.template-search__search form .search__input');
let recents = document.querySelector('.predictive-search-recent');
let recentWrap = document.querySelector('.recent-wrap');
let searchStatus = document.querySelector('.predictive-search-status')
function searchMatch(data) {
  let searched = document.querySelector("#Search-In-Modal").value.trim();
  if (searched !== "") {
    let text = data.innerHTML.replace(/\n|<.*?>/g,'');
    console.log(text,'text');
    // var spans = document.getElementsByTagName("span");
    // text.removeChild(spans)
    let re = new RegExp(searched, "gi"); // search for all instances
    console.log(re)
    searched = searched.charAt(0).toUpperCase() + searched.slice(1);
    let newText = text.replace(re, `<span style="color:#1b7c94;">${searched}</span>`);
    data.innerHTML = newText;
  }
}

if (localStorage.getItem('recentSearches')) {
  recentSearches = JSON.parse(localStorage.getItem('recentSearches'));
} else {
  localStorage.setItem("recentSearches", '[]');
}
(function () {
  let reversed = recentSearches.reverse();
  reversed.forEach(function (data, idx) {
    if (idx <= 3 && data !== "") {
      let span = document.createElement("span");
      span.innerHTML = data;
      recentWrap && recentWrap.appendChild(span);
    }
  })
})()
navSearchBar?.addEventListener('click', function () {
  if (this.value === "") {
    recents.style.display = "block";
  } else {
    recents.style.display = "none";
  }
})
navSearchBar?.addEventListener('focus', function () {
  let recentSearchValues = document.querySelectorAll('.predictive-search-recent span');
  recentSearchValues.forEach((elem) => {
    elem.addEventListener('click', () => {
      navSearchBar.value = elem.innerText;
      navSearchBar?.dispatchEvent(new Event('input'));
    })
  })
})
navSearchBar?.addEventListener('input', function () {
    //console.log(secondInterval,firstInterval)
  if (this.value === "") {
    recents.style.display = "block";
  } else {
    recents.style.display = "none";
    const firstInterval = setInterval(function () {
      console.log('initial');
      if (searchStatus.getAttribute('aria-hidden') == 'true') {
        const secondInterval = setInterval(function () {
          console.log('initial 2');
          if (searchStatus.getAttribute('aria-hidden') == 'false') {
            let datas = document.querySelectorAll('.predictive-search__item-heading');
            datas.forEach(function (data) {
              searchMatch(data);
            })
            clearInterval(secondInterval);
          }
        }, 1000)
      }
      clearInterval(firstInterval)
    }, 1);
  }
})
navForm.addEventListener('submit', function (e) {
  recentSearches.push(navSearchBar.value);
  localStorage.setItem("recentSearches", JSON.stringify(recentSearches));
})
if (searchPageForm) {
  searchPageForm.addEventListener('submit', function (e) {
    recentSearches.push(searchPageInput.value);
    localStorage.setItem("recentSearches", JSON.stringify(recentSearches));
  })
}
document.body.addEventListener('click', function (e) {
  if (!e.target.classList.contains('search__input')) {
    setTimeout(() => {
      if (!document.querySelector('details-modal.header__search > details')?.getAttribute('open')) {
        navSearchBar.value = '';
        if (recents) recents.style.display = "none";
        document.querySelector('predictive-search').removeAttribute('open');
      }
    }, 100)
  }
})



// Header height Spacing
// if (document.querySelector('#shopify-section-header .header-wrapper')) {
//   let announceBar = document.querySelector('.announcement-bar')?.offsetHeight || 0;
//   let spacing = document.querySelector('#shopify-section-header .header-wrapper').offsetHeight + announceBar;
//   document.querySelector('#shopify-section-announcement-bar').style.marginTop = spacing + 'px';
// }

// Menu items scroll to top 
document.body.addEventListener('click', function(){
  document.querySelectorAll('summary.header__menu-item').forEach(function(summary){
    if(summary.getAttribute('aria-expanded') == 'true'){
      // console.log(summary.getAttribute('aria-expanded'))
      // console.log(summary)
      // console.log(summary.querySelector('.header__submenu'))
      summary.parentElement.querySelector('ul.header__submenu') && summary.parentElement.querySelector('ul.header__submenu').scrollTo(0,0)
    }
  })
  if(!document.querySelector('#cartOffcanvasSidebar').classList.contains('show')){
    document.querySelector('#cartOffcanvasSidebar').scrollTo(0,0);
  }
})
class RatingSlider {
	constructor(domNode) {
		this.sliderNode = domNode;

		this.isMoving = false;

		this.svgNode = domNode.querySelector('svg');

		// Inherit system text colors
		//    var  color = getComputedStyle(this.sliderNode).color;
		//    this.svgNode.setAttribute('color', color);

		this.starsWidth = 198;
		this.starsX = 0;

		this.svgPoint = this.svgNode.createSVGPoint();

		// define possible slider positions

		this.sliderNode.addEventListener(
			'keydown',
			this.onSliderKeydown.bind(this)
		);

		this.svgNode.addEventListener('click', this.onRailClick.bind(this));
		this.svgNode.addEventListener(
			'pointerdown',
			this.onSliderPointerDown.bind(this)
		);

		// bind a pointermove event handler to move pointer
		this.svgNode.addEventListener(
			'pointermove',
			this.onPointerMove.bind(this)
		);
		this.svgNode.addEventListener('click', () => {
			this.submitRating(this.getValue());
		});

		// bind a pointerup event handler to stop tracking pointer movements
		document.addEventListener('pointerup', this.onPointerUp.bind(this));

		this.addTotalStarsToRatingLabel();
		this.sliderNode.addEventListener(
			'blur',
			this.addTotalStarsToRatingLabel.bind(this)
		);
	}

	submitRating(v) {
		// do something here after completing providing the rating
		// console.log('submit', v);
	}

	// Get point in global SVG space
	getSVGPoint(event) {
		this.svgPoint.x = event.clientX;
		this.svgPoint.y = event.clientY;
		return this.svgPoint.matrixTransform(
			this.svgNode.getScreenCTM().inverse()
		);
	}

	getValue() {
		return parseFloat(this.sliderNode.getAttribute('aria-valuenow'));
	}

	getValueMin() {
		return parseFloat(this.sliderNode.getAttribute('aria-valuemin'));
	}

	getValueMax() {
		return parseFloat(this.sliderNode.getAttribute('aria-valuemax'));
	}

	isInRange(value) {
		let valueMin = this.getValueMin();
		let valueMax = this.getValueMax();
		return value <= valueMax && value >= valueMin;
	}

	getValueText(value) {
		switch (value) {
			case 0:
				return 'zero stars';

			case 0.5:
				return 'one half star';

			case 1.0:
				return 'one star';

			case 1.5:
				return 'one and a half stars';

			case 2.0:
				return 'two stars';

			case 2.5:
				return 'two and a half stars';

			case 3.0:
				return 'three stars';

			case 3.5:
				return 'three and a half stars';

			case 4.0:
				return 'four stars';

			case 4.5:
				return 'four and a half stars';

			case 5.0:
				return 'five stars';

			default:
				break;
		}

		return 'Unexpected value: ' + value;
	}

	getValueTextWithMax(value) {
		switch (value) {
			case 0:
				return 'zero of five stars';

			case 0.5:
				return 'one half of five stars';

			case 1.0:
				return 'one of five stars';

			case 1.5:
				return 'one and a half of five stars';

			case 2.0:
				return 'two of five stars';

			case 2.5:
				return 'two and a half of five stars';

			case 3.0:
				return 'three of five stars';

			case 3.5:
				return 'three and a half of five stars';

			case 4.0:
				return 'four of five stars';

			case 4.5:
				return 'four and a half of five stars';

			case 5.0:
				return 'five of five stars';

			default:
				break;
		}

		return 'Unexpected value: ' + value;
	}

	moveSliderTo(value) {
		let valueMax, valueMin;

		valueMin = this.getValueMin();
		valueMax = this.getValueMax();

		value = Math.min(Math.max(value, valueMin), valueMax);

		this.sliderNode.setAttribute('aria-valuenow', value);

		this.sliderNode.setAttribute(
			'aria-valuetext',
			this.getValueText(value)
		);
	}

	onSliderKeydown(event) {
		var flag = false;
		var value = this.getValue();
		var valueMin = this.getValueMin();
		var valueMax = this.getValueMax();

		switch (event.key) {
			case 'ArrowLeft':
			case 'ArrowDown':
				this.moveSliderTo(value - 0.5);
				flag = true;
				break;

			case 'ArrowRight':
			case 'ArrowUp':
				this.moveSliderTo(value + 0.5);
				flag = true;
				break;

			case 'PageDown':
				this.moveSliderTo(value - 1);
				flag = true;
				break;

			case 'PageUp':
				this.moveSliderTo(value + 1);
				flag = true;
				break;

			case 'Home':
				this.moveSliderTo(valueMin);
				flag = true;
				break;

			case 'End':
				this.moveSliderTo(valueMax);
				flag = true;
				break;

			default:
				break;
		}

		if (flag) {
			event.preventDefault();
			event.stopPropagation();
		}
	}

	addTotalStarsToRatingLabel() {
		let valuetext = this.getValueTextWithMax(this.getValue());
		this.sliderNode.setAttribute('aria-valuetext', valuetext);
	}

	onRailClick(event) {
		var x = this.getSVGPoint(event).x;
		var min = this.getValueMin();
		var max = this.getValueMax();
		var diffX = x - this.starsX;
		var value =
			Math.round((2 * (diffX * (max - min))) / this.starsWidth) / 2;
		this.moveSliderTo(value);

		event.preventDefault();
		event.stopPropagation();
		// Set focus to the clicked handle
		this.sliderNode.focus();
	}

	onSliderPointerDown(event) {
		this.isMoving = true;

		event.preventDefault();
		event.stopPropagation();

		// Set focus to the clicked handle
		this.sliderNode.focus();
	}

	onPointerMove(event) {
		if (this.isMoving) {
			var x = this.getSVGPoint(event).x;
			var min = this.getValueMin();
			var max = this.getValueMax();
			var diffX = x - this.starsX;
			var value =
				Math.round((2 * (diffX * (max - min))) / this.starsWidth) / 2;
			this.moveSliderTo(value);

			event.preventDefault();
			event.stopPropagation();
		}
	}

	onPointerUp() {
		this.isMoving = false;
		this.submitRating(this.getValue());
	}
}

class RatingStar extends HTMLElement {
	constructor() {
		super();
		this.init();
	}
	init() {
		// Initialize RatingSliders on the page
		new RatingSlider(this);
		// window.addEventListener('load', () => {
		// 	var sliders = this.querySelectorAll('.rating-slider');
		// 	for (let i = 0; i < sliders.length; i++) {
		// 	}
		// });
	}
}
customElements.define('rating-star', RatingStar);

function noenter(e) {
    e = e || window.event;
    var key = e.keyCode || e.charCode;
    //alert('e.type: ' + e.type + '; key: ' + key);
    return key !== 13; 
}

  class VideoModal extends HTMLElement {
		constructor() {
			super();
			this.modal = this;
			this.modelOpener = document.getElementById('open-video-modal');
      this.modalCloseButton = this.querySelector('.close');
      this.VideoPlayer = this.querySelector('.video_player');
      this.html = document.querySelector('html');
      this.body = document.querySelector('body');
      this.window = window;
      this.controls = this.dataset.controls;
      this.autoplay = this.dataset.autoplay;
      this.loop = this.dataset.loop;
      this.muted = this.dataset.muted;
			this.init();
		}

		bindEvents() {
			this.modelOpener?.addEventListener('click', this.onOpen.bind(this));
			this.modalCloseButton?.addEventListener('click', this.onClose.bind(this));
			this.window.addEventListener('click', this.onOverlayClick.bind(this));
		}

		init() {
			this.bindEvents();
		}

		onOpen() {
      this.modal.style.display = 'flex';
      this.html?.classList.add('scroll-locked');
      this.body?.classList.add('scroll-locked');
      if (this.controls) {
        this.VideoPlayer?.setAttribute('controls', '')
      };
      if (this.autoplay) {
        this.VideoPlayer?.setAttribute('autoplay', '');
        this.VideoPlayer?.play();
      };
      if (this.loop) {
        this.VideoPlayer?.setAttribute('loop', '')
      };
      if (this.muted) {
        this.VideoPlayer?.setAttribute('muted', '')
      };
		}

		onClose() {
      this.modal.style.display = 'none';
      this.html?.classList.remove('scroll-locked');
      this.body?.classList.remove('scroll-locked');
      this.VideoPlayer?.pause();
      if (this.controls) {
        this.VideoPlayer?.removeAttribute('controls')
      };
      if (this.autoplay) {
        this.VideoPlayer?.removeAttribute('autoplay')
      };
      if (this.loop) {
        this.VideoPlayer?.removeAttribute('loop')
      };
      if (this.muted) {
        this.VideoPlayer?.removeAttribute('muted')
      };
		}

		onOverlayClick(event) {
			if (event.target == this.modal) {
				this.onClose();
			}
		}
  }
  customElements.define('video-modal', VideoModal);

class UtilityNav extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.body = document.querySelector('body');
		this.UtilityNav = document.getElementById(
			'shopify-section-utility-nav'
		);
		this.header = this.body?.querySelector('shopify-sticky-header');
		this.UtilityNavBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideUtilityNavOnScrollUp = () => (this.preventReveal = true);

		this.addEventListener(
			'preventHeaderReveal',
			this.hideUtilityNavOnScrollUp
		);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener(
			'preventHeaderReveal',
			this.hideUtilityNavOnScrollUp
		);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
			this.UtilityNavBounds = entries[0].intersectionRect;
			observer.disconnect();
		});

		observer.observe(this.UtilityNav);
	}

	onScroll() {
		const scrollTop =
			window.pageYOffset || document.documentElement.scrollTop;

		if (
			scrollTop > this.currentScrollTop &&
			scrollTop > this.UtilityNavBounds?.bottom
		) {
			requestAnimationFrame(this.hide.bind(this));
		} else if (
			scrollTop < this.currentScrollTop &&
			scrollTop > this.UtilityNavBounds?.bottom
		) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 33);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.UtilityNavBounds?.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		this.UtilityNav?.classList.add(
			'shopify-section-UtilityNav-hidden',
			'shopify-section-UtilityNav-sticky'
		);
		this.body?.classList.add('started_scrolling', 'going_down');
		this.header?.classList.add(
			'shopify-section-header-hidden',
			'shopify-section-header-sticky'
		);
		this.closeMenuDisclosure();
		this.closeSearchModal();
	}

	reveal() {
		this.UtilityNav?.classList.add(
			'shopify-section-UtilityNav-sticky',
			'animate'
		);
		this.UtilityNav?.classList.remove('shopify-section-UtilityNav-hidden');
		this.body?.classList.remove('going_down');
		this.body?.classList.add('going_up');
		this.header?.classList.add('shopify-section-header-sticky', 'animate');
		this.header?.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		this.UtilityNav?.classList.remove(
			'shopify-section-UtilityNav-hidden',
			'shopify-section-UtilityNav-sticky',
			'animate'
		);
		this.body?.classList.remove(
			'started_scrolling',
			'going_up',
			'going_down'
		);
		this.header?.classList.remove(
			'shopify-section-header-hidden',
			'shopify-section-header-sticky',
			'animate'
		);
	}

	closeMenuDisclosure() {
		this.disclosures =
			this.disclosures ||
			this.UtilityNav?.querySelectorAll('details-disclosure');
		this.disclosures?.forEach((disclosure) => disclosure?.close());
	}

	closeSearchModal() {
		this.searchModal =
			this.searchModal || this.header?.querySelector('details-modal');
		this.searchModal?.close(false);
	}
}

customElements.define('utility-nav', UtilityNav);

class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

  connectedCallback() {
      this.body = document.querySelector('body');
      this.header = this.parentElement;
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds?.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds?.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds?.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header?.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.body?.classList.add('started_scrolling', 'going_down');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header?.classList.add('shopify-section-header-sticky', 'animate');
      this.body?.classList.remove('going_down');
		  this.body?.classList.add('going_up');
      this.header?.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header?.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      this.body?.classList.remove(
			'started_scrolling',
			'going_up',
			'going_down'
		);
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header?.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header?.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);


document.addEventListener('load', function () {
	let header = document.querySelector('header.dexcom-header');
	let headerOffsetHeight = header?.getBoundingClientRect().bottom;
	document.documentElement.style.setProperty(
		'--main-top',
		`${headerOffsetHeight}px`
	);
});
class DesktopSearch {
  constructor(selector) {
    this.element = document.querySelector(selector)

    document.addEventListener("DOMContentLoaded", this.domLoadHandler.bind(this));
  }

  domLoadHandler() {
    let searchbutton = this.element.querySelector(".js__searchbutton");
    let searchinput = this.element.querySelector(".js_search_field");
    searchbutton.addEventListener("click", this.btnClickHandler.bind(this));
    searchinput.addEventListener("focusout",this.focusOutHandler.bind(this) );
  }
  btnClickHandler(){
    let searchinput = this.element.querySelector(".js_search_field");
    if (searchinput.classList.contains("active")) {
      searchinput.classList.remove("active");
    } else {
      searchinput.classList.add("active");
    }
  }
  focusOutHandler(){
    setTimeout(() => {
      let searchinput = this.element.querySelector(".js_search_field");
      const pred = searchinput.closest("predictive-search");
      if (pred && pred.contains(document.activeElement)) return;
      if (searchinput.classList.contains("active")) {
        searchinput.classList.remove("active");
        pred.removeAttribute("open");
      } else {
        searchinput.classList.add("active");
      }
    });
  }
}
new DesktopSearch(".js__desktop_search");

class MobileSearch extends DesktopSearch {
  constructor(selector) {
    super(selector)
  }
  btnClickHandler(){
  }
  focusOutHandler(){
    setTimeout(() => {
      let searchinput = this.element.querySelector(".js_search_field");
      const pred = searchinput.closest("predictive-search");
      if (pred && pred.contains(document.activeElement)) return;
    });
  }
}

new MobileSearch(".js__mobile_search");

